import { ChargingStationDetail } from '@shared/models/business/charging-station-detail.model';

export class EnergyCost {
	cost: number;
	yearlyInflation: number;
	adblue?: number;
	dieselCost?: number;
	chargingStationList: ChargingStationDetail[];
}
